module.exports = __webpack_public_path__ + "static/media/truid-verify-icon.cc6fbef1.png";